import React from "react";

const TypingAnimation = () => (
  <div className="typing">
    <div className="typing-dot"></div>
    <div className="typing-dot"></div>
    <div className="typing-dot"></div>
  </div>
);

export default TypingAnimation;
